import { BitrixVue } from "ui.vue";

BitrixVue.component("ButtonSelect", {
	data() {
		return {};
	},
	props: ["state", "buttonText"],
	mounted() {},
	template: `
		<div class="config-btn__select" @click="$emit('setActiveButton')">{{this.buttonText}}</div>
`,
});
